import styles from "./RulesList.module.scss";

const TruckTypesDisplay = ({ allTruckTypes, allowedTruckTypes }) => {
  const formatTruckTypes = (allTruckTypes, allowedTruckTypes) => {
    // If all truck types are explicitly set to true, show "All truck types"
    if (allTruckTypes === true) return "All truck types";
    
    // If allTruckTypes is false, check for specific truck types
    if (allTruckTypes === false) {
      // If no specific truck types configured, show "No truck types"
      if (!allowedTruckTypes) return "No truck types";
      
      // Handle both comma-separated strings and arrays
      let typesArray;
      if (typeof allowedTruckTypes === 'string') {
        typesArray = allowedTruckTypes.split(',').map(type => type.trim()).filter(type => type);
      } else if (Array.isArray(allowedTruckTypes)) {
        typesArray = allowedTruckTypes.filter(type => type);
      } else {
        return "No truck types";
      }
      
      if (typesArray.length === 0) return "No truck types";
      if (typesArray.length === 1) return typesArray[0];
      if (typesArray.length <= 3) return typesArray.join(", ");
      return `${typesArray.slice(0, 2).join(", ")} +${typesArray.length - 2} more`;
    }
    
    // Default case: assume all truck types accepted for backward compatibility
    return "All truck types";
  };

  const displayText = formatTruckTypes(allTruckTypes, allowedTruckTypes);

  return (
    <span className={styles.truckTypesText}>
      {displayText}
    </span>
  );
};

export default TruckTypesDisplay;